import { InventoryRecap } from '../../../common/inventory/models/InventoryRecap';
import { OrganizationSummary } from './OrganizationSummary';
import { PriorityFix } from './PriorityFix';

export class OrganizationData {
  constructor(private readonly summary: OrganizationSummary, private readonly priorityFixes: PriorityFix[], private readonly inventory: InventoryRecap) {}

  getSummary() {
    return this.summary;
  }

  getPriorityFixes() {
    return this.priorityFixes;
  }

  getInventory() {
    return this.inventory;
  }

  static getBlank() {
    return new OrganizationData(OrganizationSummary.getBlank(), [], InventoryRecap.getBlank());
  }
}
